export default "__VITE_ASSET__x7E_vqcf4zfljj3$lwQGUg__"